import { object, string } from "yup";

export const customerAcquirerSchema = object({
    pixAcquirer: string().required(
        "Selecione a adquirente para pagamentos via Pix."
    ),
    pixFeePercentage: string().required(
        "Informe a taxa (%) aplicada para pagamentos via Pix."
    ),
    cardAcquirer: string().required(
        "Selecione a adquirente para pagamentos via Cartão."
    ),
    cardFeePercentage: string().required(
        "Informe a taxa (%) aplicada para pagamentos via Cartão."
    ),
});
